// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ek72b","textContainer":"styles_textContainer__Nklcs","title":"styles_title__xdp-Y","subTitle":"styles_subTitle__NoWox","shadow":"styles_shadow__bZZUq"};